import { render, staticRenderFns } from "./provider_details.vue?vue&type=template&id=62047fe2&scoped=true&"
import script from "./provider_details.vue?vue&type=script&lang=js&"
export * from "./provider_details.vue?vue&type=script&lang=js&"
import style0 from "./provider_details.vue?vue&type=style&index=0&id=62047fe2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62047fe2",
  null
  
)

export default component.exports